import { render, staticRenderFns } from "./BilletPage.vue?vue&type=template&id=539bc5ac&scoped=true"
import script from "./BilletPage.vue?vue&type=script&lang=js"
export * from "./BilletPage.vue?vue&type=script&lang=js"
import style0 from "./BilletPage.vue?vue&type=style&index=0&id=539bc5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539bc5ac",
  null
  
)

export default component.exports